import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import { AuthContext } from 'api/context';
import { getDroneFrontendUrl, isDroneManagementConfigured } from 'drone';

const DroneManagment = () => {
  const { company } = useContext(AuthContext);
  if (!isDroneManagementConfigured()) return null;

  const src = new URL(`/${company}/projects`, getDroneFrontendUrl()).toString();
  return (
    <Card className="shadow-sm">
      <Card.Body style={{ height: 'calc(100vh - 140px)', padding: 0 }}>
        <iframe
          title="Drone Managment"
          src={src}
          style={{ border: 0, width: '100%', height: '100%' }}
          allow="fullscreen"
        />
      </Card.Body>
    </Card>
  );
};

export default DroneManagment;
